export const DATE_FORMAT_MOMENT = 'DD/MM/YYYY';
export const DATE_TIME_FORMAT_MOMENT = 'DD/MM/YYYY HH:mm';
export const DATE_TIME_FORMAT_MOMENT_DOTS = 'DD.MM.YYYY, HH:mm';
export const DATE_FORMAT_MONTH_YEAR = 'MMMM,YYYY';
export const DATE_LOCAL_FORMAT = 'YYYY-MM-DD[T]HH:mm:ss';
export const MAX_FILE_SIZE = 18874368; // 18 mb

export function featureEnabled(name: string) {
  return window.appSettings.features[name] === true || getLocalFeatureSettings()[name] === true;
}

function getLocalFeatureSettings() {
  const featureSettingsStored = localStorage.getItem('feature-settings');
  return featureSettingsStored ? JSON.parse(featureSettingsStored) : {};
}

(window as any).updateLocalFeature = (name: string, enabled: boolean) => {
  const featureSettings = getLocalFeatureSettings();
  featureSettings[name] = enabled;
  localStorage.setItem('feature-settings', JSON.stringify(featureSettings));

  // eslint-disable-next-line
  window.location.href = window.location.href;
};
